// extracted by mini-css-extract-plugin
export default {"options":"_3OoazS2en3UiRxtb1sfsmL","pages":"_1NWg9EcbhGOsSMQeSzmwaD","menu":"_3dMioQqayNFb3YtbFHb2eF","menuWithoutSearch":"j0kytlDCtPFZ02XpNpkBH"};